var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"outline"},[_c('div',{staticClass:"menu"},[_c('span',{on:{"!click":function($event){_vm.action('top')}}},[_vm._v("上方添加")]),_vm._v(" "),_c('span',{on:{"!click":function($event){_vm.action('bottom')}}},[_vm._v("下方添加")]),_vm._v(" "),_c('span',{on:{"!click":function($event){_vm.action('delete')}}},[_vm._v("删除")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37a873f6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageEditor/outline.vue
// module id = null
// module chunks = 